import React from 'react';

import { VendorProvider } from 'contexts/vendor.context';
import VendorsContent from './content';

const VendorsLayout = () => {
  return (
    <VendorProvider>
      <VendorsContent />
    </VendorProvider>
  );
};

export default VendorsLayout;
